export default __webpack_public_path__ + "static/media/C&BMaterials-banner.10a1ef07.jpg";